import { useAllowedPagesForUser } from "hooks/hooks";
import { useNavigate } from "react-router";

export const useAppNavigate = () => {
	const { allowedPagesForRole, allowedPagesForCustomer } = useAllowedPagesForUser();

	const navigate = useNavigate();
	const navigateToPage = (path: string) => {
		// If the customer has access to the page, navigate to it
		const allowedPathsForCustomer = allowedPagesForCustomer.map((page) => page.path);
		if (allowedPathsForCustomer.includes(path)) {
			navigate(path);
		}
	};

	return { allowedPagesForRole, navigateToPage };
};
